



























import { Component, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import jwtService from '@/services/common/jwt.service';
import authModule from '@/store/modules/common/auth.module';
import VAvatar from '@/components/avatar/VAvatar.vue';
import authService from '@/services/common/auth.service';
import { User } from '@/store/models';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';

@Component({ name: 'VUserAvatar', components: { VAvatar } })
export default class VUserAvatar extends Mixin {
  @Prop({ required: false }) size?: { width: number; height: number };
  public show = false;

  public al() {
    console.log('sss');
  }
  get user() {
    return authModule.user;
  }

  public openPhoto() {
    this.show = false;
    document.getElementById('fileUpload')?.click();
  }

  public async handleFileChange(event: any) {
    const files: FileList = event.target.files;
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (files && validImageTypes.includes(files[0].type)) {
      await authService.changeAvatar(files[0]);
      await authModule.getAdminInfo();
    } else {
      await messageModule.showMessage({
        message: 'Please choose image type (.png/.jpg/.gif).',
        type: MessageType.danger
      });
    }
  }

}
